import produce, { Draft } from 'immer';
import { noop } from 'lodash';
import { Moment } from 'moment';
import { create } from 'zustand';

export type IOfferDetailsModalExpired = {
  showModalExpiredItemsInCart: boolean;
  setShowModalExpiredItemsInCart: (show: boolean) => void;
};

export type IOfferDetailsProductBuy = {
  billingDateValue: Moment | null;
  deliveryDateValue: Moment | null;
  setBillingDateValue: (date: Moment | null) => void;
  setDeliveryDateValue: (date: Moment | null) => void;
};

export type IOfferDetailsModalInformation = {
  displayModalInformation: boolean;
  setDisplayModalInformation: (display: boolean) => void;
  handleOnConfirmationDeliveryDate: () => void;
  setHandleOnConfirmationDeliveryDate: (func: () => void) => void;
};

export type IOfferDetailsModalInformationComposition = {
  displayModalInformationComposition: boolean;
  setDisplayModalInformationComposition: (display: boolean) => void;
  handleOnConfirmationDeliveryDateComposition: () => void;
  setHandleOnConfirmationDeliveryDateComposition: (func: () => void) => void;
};

export type IOfferDetailsStore = {
  fastBuy: boolean;
  isLoading: boolean;
  hasShippingFee: boolean;
  setData: (fn: (state: Draft<IOfferDetailsStore>) => void) => void;
  setFastBuy: (fastBuy: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  setShippingFee: (hasFee: boolean) => void;
} & IOfferDetailsModalExpired &
  IOfferDetailsProductBuy &
  IOfferDetailsModalInformation &
  IOfferDetailsModalInformationComposition;

const offerDetailsStore = create<IOfferDetailsStore>()((set, get) => ({
  fastBuy: false,
  isLoading: false,
  hasShippingFee: false,
  showModalExpiredItemsInCart: false,
  billingDateValue: null,
  deliveryDateValue: null,
  displayModalInformation: false,
  displayModalInformationComposition: false,
  handleOnConfirmationDeliveryDate: noop,
  handleOnConfirmationDeliveryDateComposition: noop,

  setData: (fn) => set(produce(fn)),
  setFastBuy: (fastBuy: boolean) => {
    get().setData((state) => {
      state.fastBuy = fastBuy;
    });
  },
  setIsLoading: (isLoading: boolean) => {
    get().setData((state) => {
      state.isLoading = isLoading;
    });
  },
  setShippingFee: (hasFee: boolean) => {
    get().setData((state) => {
      state.hasShippingFee = hasFee;
    });
  },

  // Modal Expired
  setShowModalExpiredItemsInCart: (show: boolean) => {
    get().setData((state) => {
      state.showModalExpiredItemsInCart = show;
    });
  },

  // ProductBuy
  setBillingDateValue: (date: Moment | null) => {
    get().setData((state) => {
      state.billingDateValue = date;
    });
  },
  setDeliveryDateValue: (date: Moment | null) => {
    get().setData((state) => {
      state.deliveryDateValue = date;
    });
  },

  // Modal Information
  setDisplayModalInformation: (display: boolean) => {
    get().setData((state) => {
      state.displayModalInformation = display;
    });
  },
  setHandleOnConfirmationDeliveryDate: (func: () => void) => {
    get().setData((state) => {
      state.handleOnConfirmationDeliveryDate = func;
    });
  },

  // Modal Information Composition
  setDisplayModalInformationComposition: (display: boolean) => {
    get().setData((state) => {
      state.displayModalInformationComposition = display;
    });
  },
  setHandleOnConfirmationDeliveryDateComposition: (func: () => void) => {
    get().setData((state) => {
      state.handleOnConfirmationDeliveryDateComposition = func;
    });
  },
}));

export default offerDetailsStore;
